<template>
  <div>
    <b-modal
      v-model="isModalPagamentoOpen"
      :title="modalTitle"
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header class="pb-0">
        <div v-show="false" class="w-100 pb-0">
          <b-row>
            <!-- b-col class="text-left">
                            <h4>{{ modalTitle }}</h4>
                        </b-col -->
            <!-- <b-col class="text-right">
                            <button @click.prevent="showSuccessAlert ? closeModalSucesso() : confirmCloseModalPix()" type="button" aria-label="Close" class="close">×</button>
                        </b-col> -->
          </b-row>
        </div>
      </template>

      <div v-if="!isPaymentLater" class="mt-0 pt-0">
        <div v-if="shouldShowDescription">
          <div v-if="!endedCountdown">
            <b-row class="text-center">
              <b-col>
                <h5>
                  {{
                    formatDescription(expressBookingResponse.description) ||
                    'Gerando QRCode PIX...'
                  }}
                </h5>
              </b-col>
            </b-row>

            <b-row v-if="!isOnline" class="text-center pt-1">
              <b-col>
                <h5>
                  Dispositivo offline! O pagamento será confirmado via
                  Whatsapp/email/SMS.
                </h5>
              </b-col>
            </b-row>

            <b-row v-if="paymentStatusMessage.showPaymentStatusMessage">
              <b-col>
                <b-alert
                  :show="paymentStatusMessage.showPaymentStatusMessage"
                  variant="warning"
                >
                  {{ paymentStatusMessage.message }}
                </b-alert>
              </b-col>
            </b-row>

            <b-row class="text-center pt-2 pb-4">
              <b-col>
                <qrcode-vue
                  v-if="hasAdditionalData"
                  class="svg"
                  renderAs="svg"
                  :size="250"
                  :value="expressBookingResponse.additional_data.qr_code"
                />
              </b-col>
            </b-row>
          </div>

          <b-row class="text-center">
            <b-col v-if="hasAdditionalData && !endedCountdown">
              <h5>
                O Código Pix irá expirar em:
                <el-statistic
                  :value="new Date(expirationDate)"
                  format="mm:ss"
                  time-indices
                  @finish="endCountdown"
                />
              </h5>
            </b-col>

            <b-col v-else-if="endedCountdown">
              <h5>Código Expirado!</h5>
            </b-col>
          </b-row>

          <b-row v-if="hasAdditionalData" class="text-center">
            <b-col>
              <b-button
                @click="copyTextToClipboard('pix')"
                :disabled="endedCountdown"
                variant="basic"
                class="rounded-pill"
              >
                Copiar Código Pix
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div v-else-if="isCortesiaSucesso">
          <div class="d-flex justify-content-center">
            <svg
              width="179"
              height="179"
              viewBox="0 0 179 179"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="90" cy="90" r="67" fill="#A6AB38" />
              <path
                d="M59 90.6465L89.1237 123.983L116.281 60"
                stroke="white"
                stroke-width="15"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M89 165.832V179M89 0V13.1678"
                stroke="#A6AB38"
                stroke-width="3"
              />
              <path
                d="M165.832 92L179 92M0 92L13.1678 92"
                stroke="#A6AB38"
                stroke-width="3"
              />
              <path
                d="M143.596 37.7077L152.907 28.3966M26.335 154.969L35.646 145.658"
                stroke="#A6AB38"
                stroke-width="3"
              />
              <path
                d="M35.6472 37.7077L26.3361 28.3966M152.908 154.969L143.597 145.658"
                stroke="#A6AB38"
                stroke-width="3"
              />
            </svg>
          </div>

          <b-row class="text-center pt-4 pb-4">
            <b-col>
              <span v-if="expressBookingResponse.split('code')[1]"
                >Reserva Cortesia
                <b>#{{ expressBookingResponse.split('code')[1] }}</b>
                registrada!</span
              >
              <span v-else>aguarde...</span>
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-row class="text-center">
            <b-col>
              <span>aguarde...</span>
            </b-col>
          </b-row>
        </div>

        <div v-if="showSuccessAlert">
          <b-alert
            :show="showSuccessAlert"
            style="
              background-color: white;
              border: 0;
              margin-bottom: 0;
              padding: 0;
            "
          >
            <div class="d-flex justify-content-center">
              <div>
                <h4 class="alert-heading text-center text-black">
                  Pagamento concluído.
                </h4>
                <p class="text-center text-black">
                  Sucesso ao realizar o pagamento!
                </p>

                <div class="d-flex justify-content-center">
                  <svg
                    width="179"
                    height="179"
                    viewBox="0 0 179 179"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="90" cy="90" r="67" fill="#A6AB38" />
                    <path
                      d="M59 90.6465L89.1237 123.983L116.281 60"
                      stroke="white"
                      stroke-width="15"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M89 165.832V179M89 0V13.1678"
                      stroke="#A6AB38"
                      stroke-width="3"
                    />
                    <path
                      d="M165.832 92L179 92M0 92L13.1678 92"
                      stroke="#A6AB38"
                      stroke-width="3"
                    />
                    <path
                      d="M143.596 37.7077L152.907 28.3966M26.335 154.969L35.646 145.658"
                      stroke="#A6AB38"
                      stroke-width="3"
                    />
                    <path
                      d="M35.6472 37.7077L26.3361 28.3966M152.908 154.969L143.597 145.658"
                      stroke="#A6AB38"
                      stroke-width="3"
                    />
                  </svg>
                </div>

                <div class="text-center">
                  <qrcode-vue
                    style="display: none"
                    class="svg"
                    :size="150"
                    :value="qrCodeOrderUrl"
                  />

                  <h4 class="mt-3 alert-heading text-black">
                    Link da reserva disponível!
                  </h4>

                  <!-- <b-button v-if="usedDevice != 'TOTEM'" @click="copyTextToClipboard('successPayment')" size="lg" variant="back" class="rounded-pill mb-4">
                                        <i class="fas fa-copy"></i> Copiar Link da reserva
                                    </b-button> -->
                </div>
              </div>
            </div>
          </b-alert>
        </div>
      </div>

      <div v-else>
        <div class="d-flex justify-content-center">
          <svg
            width="100"
            height="100"
            viewBox="0 0 179 179"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="90" cy="90" r="67" fill="#A6AB38" />
            <path
              d="M59 90.6465L89.1237 123.983L116.281 60"
              stroke="white"
              stroke-width="15"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M89 165.832V179M89 0V13.1678"
              stroke="#A6AB38"
              stroke-width="3"
            />
            <path
              d="M165.832 92L179 92M0 92L13.1678 92"
              stroke="#A6AB38"
              stroke-width="3"
            />
            <path
              d="M143.596 37.7077L152.907 28.3966M26.335 154.969L35.646 145.658"
              stroke="#A6AB38"
              stroke-width="3"
            />
            <path
              d="M35.6472 37.7077L26.3361 28.3966M152.908 154.969L143.597 145.658"
              stroke="#A6AB38"
              stroke-width="3"
            />
          </svg>
        </div>

        <b-row class="text-center pt-4 pb-4">
          <b-col>
            <span v-if="payLaterBookingCodeResponse"
              >{{
                isPaymentLater && !form.cod_booking ? 'Cotação' : 'Reserva'
              }}
              <b>#{{ payLaterBookingCodeResponse }}</b> registrada!</span
            >
            <span v-else-if="localPaymentError" class="text-danger">{{
              localPaymentError
            }}</span>
            <span v-else>aguarde...</span>
            <small v-if="localPaymentFinanceError" class="d-block pt-2">
              A reserva foi registrada, mas a conta não foi aberta.
              {{ localPaymentFinanceError }}
            </small>
          </b-col>
        </b-row>
        <b-row v-if="!form.cod_booking">
          <b-col class="pt-4">
            <small
              >*sua reserva ainda depende da disponibilidade de vagas do dia!
              Acesse o link de pagamento disponível nos detalhes da reserva e
              garanta sua vaga!</small
            >
          </b-col>
        </b-row>
        <b-row v-if="!form.cod_booking">
          <b-col>
            <small
              >*pagamento via link disnponível até
              <b class="text-danger">
                {{
                  getLimitPaymentDate()
                    .replace('00:00', '0h')
                    .replace(':', 'h')
                    .replace('00', '')
                }}</b
              >.</small
            >
          </b-col>
        </b-row>
      </div>

      <template #modal-footer>
        <div
          v-if="showSuccessAlert"
          class="d-flex justify-content-center"
          style="width: 60%; gap: 15px"
        >
          <b-button
            v-if="usedDevice != 'TOTEM'"
            @click="copyTextToClipboard('successPayment')"
            variant="back"
            size="lg"
            class="rounded-pill mb-2"
          >
            Compartilhar
          </b-button>

          <b-button
            @click="openBookingDetails()"
            variant="success"
            class="rounded-pill pt-2 pb-2 pr-3 pl-3 mb-2"
            style="box-shadow: none"
          >
            Ver reserva
          </b-button>

          <b-button
            @click="closeModalSucesso()"
            variant="outline-danger"
            class="rounded-pill pt-2 pb-2 pr-3 pl-3 mb-2"
            >Fechar</b-button
          >
        </div>

        <div v-else>
          <div v-if="isPaymentLater">
            <b-button
              v-if="payLaterBookingCodeResponse"
              @click="openBookingDetails('_blank')"
              variant="success"
              class="rounded-pill pt-2 pb-2 pr-3 pl-3 mb-2"
              style="box-shadow: none"
            >
              Ver reserva
            </b-button>

            <b-button
              @click="closeModalSucesso()"
              variant="outline-primary"
              class="rounded-pill pt-2 pb-2 mb-2"
              >Concluir</b-button
            >
          </div>

          <div v-else>
            <div v-if="isExpressStringWithCode">
              <b-button
                @click="openBookingDetails()"
                variant="success"
                class="rounded-pill pt-2 pb-2 pr-3 pl-3 mb-2"
                style="box-shadow: none"
              >
                Ver reserva
              </b-button>

              <b-button
                @click="closeModalSucesso()"
                variant="outline-primary"
                class="rounded-pill pt-2 pb-2 mb-2"
                >Concluir</b-button
              >
            </div>

            <div v-else>
              <b-button
                @click="confirmCloseModalPix()"
                variant="outline-danger"
                class="rounded-pill pt-2 pb-2 pr-3 pl-3 mb-2"
              >
                {{ isPaymentLater ? 'Voltar' : 'Cancelar' }}
              </b-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-if="openBookingDetailsModal"
      v-model="openBookingDetailsModal"
      modal-class="fullscreen-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-header style="padding: 0; margin: 0">
        <h2 align-v="start" class="border-bottom w-100 text-left pb-2">
          {{ currentBookingModalTitle }}
        </h2>

        <div class="text-right">
          <button
            @click.prevent="closeBookingDetailsModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span @click.prevent="closeBookingDetailsModal">x</span>
          </button>
        </div>
      </template>

      <detalhesda-reserva
        v-if="openBookingDetailsModal"
        :bookingCode="bookingCodeForDetails"
        :DEVICE="DEVICE"
      />
    </b-modal>
  </div>
</template>

<script>
import DetalhesdaReserva from '../Operacao/DetalhesdaReserva.vue'
import { mapGetters, mapActions } from 'vuex'
import qrcodeVue from 'qrcode.vue'
import swal from 'sweetalert2'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import MobileDetector from 'mobile-detect'

export default {
  name: 'PagamentoModal',

  components: {
    qrcodeVue,
    DetalhesdaReserva,
  },

  inject: ['isOnline'],

  props: {
    isModalPagamentoOpen: {
      type: Boolean,
      default: false,
    },

    PAYMENT_STATUS: {
      type: String,
      default: '' | null,
    },

    isPaymentLater: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      webSocketPix: null,
      endedCountdown: false,
      showSuccessAlert: false,
      showFailureAlert: false, //showPendingAlert: false,
      DEVICE: '',
      paymentStatusMessage: {
        showPaymentStatusMessage: false,
        message: 'Aguardando pagamento...',
      },
      openBookingDetailsModal: false,
    }
  },

  watch: {
    wsStatusPaymentMP(newValue, oldValue) {
      if (
        newValue != null &&
        newValue != undefined &&
        newValue.Hash != null &&
        newValue.Hash != undefined &&
        newValue.Hash == this.bookingDetails.hash &&
        newValue.Hash.length > 0
      ) {
        if (newValue.status.toUpperCase() == 'PENDING') {
          this.paymentStatusMessage.showPaymentStatusMessage = true
        }

        if (newValue.status.toUpperCase() != 'PENDING') {
          this.paymentStatusMessage.showPaymentStatusMessage = false
          this.$parent.$emit('resetPaymentStatus', newValue.status)
          this.bookingStoreCommit({
            mutation: 'RESET_MP_CALLBACK_URL_MP',
            value: '',
          })
        }
      }
    },

    endedCountdown(newValue, oldValue) {
      if (newValue) {
        this.closeModalPix()
        swal
          .fire({
            text: 'Código QR expirado. Clique novamente em reservar para gerar um novo código.',
            icon: 'warning',
            showConfirmButton: true,
            confirmButtonText: 'Entendi',
            confirmButtonColor: '#12576e',
            cancelButtonText: 'Fechar',
            cancelButtonColor: 'secondary',
            type: 'default',
          })
          .then((result) => {
            if (result.isConfirmed) {
            }
          })
      }
    },

    isOnline(newValue, oldValue) {
      if (!newValue && !this.endedCountdown) {
        this.$notify({
          message:
            'Dispositivo offline! O pagamento será confirmado via Whatsapp/email/SMS.',
          duration: 10000,
          type: 'warning',
        })
      }
    },

    async PAYMENT_STATUS(newValue, oldValue) {
      if (newValue) {
        if (newValue.toUpperCase() == 'APPROVED') {
          this.showSuccessAlert = true
          this.showFailureAlert = false
          this.openBookingDetails()
          if (this.webSocketPix != null) {
            await this.webSocketPix.close()
          }
        }

        // if(newValue.toUpperCase() == 'PENDING'){ this.showSuccessAlert = false; this.showFailureAlert = false; await this.webSocketPix.close() }
        if (
          newValue.toUpperCase() == 'FAILURE' ||
          newValue.toUpperCase() == 'DENIED'
        ) {
          this.showSuccessAlert = false
          this.showFailureAlert = true
          if (this.webSocketPix != null) {
            await this.webSocketPix.close()
          }
        }
      }
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
      expressBookingResponse: 'getExpressBookingResponse',
      wsStatusPaymentMP: 'getWsStatusPaymentMP',
    }),

    ...mapGetters('operacao', {
      bookingFromRoute: 'getBookingDetails',
    }),

    bookingDetails() {
      if (this.form) {
        return this.form
      } else if (!this.isPaymentLater && this.bookingFromRoute.length > 0) {
        return this.bookingFromRoute[0]
      }
      return null
    },

    bookingCodeForDetails() {
      if (
        this.expressBookingResponse.description &&
        this.expressBookingResponse.description.length > 0
      ) {
        return this.bookingDetails
          ? this.bookingDetails.bookingCode
            ? this.bookingDetails.bookingCode
            : this.bookingDetails.hash
          : this.wsStatusPaymentMP.Hash
      } else if (this.isPaymentLater) {
        return this.payLaterBookingCodeResponse
      } else {
        return this.expressBookingResponse.split('code')[1].trim()
      }
    },

    shouldShowDescription() {
      return (
        !this.showSuccessAlert &&
        this.expressBookingResponse &&
        this.expressBookingResponse.description
      )
    },

    hasAdditionalData() {
      return (
        this.expressBookingResponse &&
        this.expressBookingResponse.additional_data
      )
    },

    isCortesiaSucesso() {
      return (
        !this.showSuccessAlert &&
        (!this.expressBookingResponse ||
          !this.expressBookingResponse.description) &&
        typeof this.expressBookingResponse == 'string' &&
        this.expressBookingResponse.length > 0
      )
    },

    isExpressStringWithCode() {
      return (
        typeof this.expressBookingResponse === 'string' &&
        this.expressBookingResponse.length > 0
      )
    },

    payLaterBookingCodeResponse() {
      const response = this.expressBookingResponse
      if (response && typeof response === 'object') {
        return response.booking_code || null
      }
      if (this.isPaymentLater && typeof response === 'string' && response.length > 0) {
        var text = JSON.parse(JSON.stringify(response)).toString()
        let bookingCode = text.split('code')[1].trim()
        return bookingCode
      }
      return null
    },

    localPaymentError() {
      const response = this.expressBookingResponse
      if (!response || typeof response !== 'object' || !response.error) return ''
      return response.error
    },

    localPaymentFinanceError() {
      const response = this.expressBookingResponse
      if (!response || typeof response !== 'object' || !response.finance_error) {
        return ''
      }
      return response.finance_error
    },

    expirationDate() {
      if (this.expressBookingResponse.additional_data != undefined) {
        return moment(
          this.expressBookingResponse.additional_data.expiration_date_qrcode
        )
          .add(3, 'hours')
          .add(16, 'seconds')
      }
      return null
    },

    qrCodeOrderUrl() {
      const HASH =
        this.bookingDetails.bookingCode != undefined
          ? this.bookingDetails.bookingCode.toUpperCase()
          : ''
      return window.location.origin + '/booking-details/' + HASH
    },

    modalTitle() {
      if (this.isPaymentLater) {
        return 'Pagamento posterior'
      } else {
        return 'Pagamento'
      }
    },

    currentBookingModalTitle() {
      if (this.openBookingDetailsModal) {
        return `Detalhes da reserva #${this.bookingCodeForDetails}`
      }
      return ''
    },

    usedDevice() {
      const userAgent = window.navigator.userAgent
      const md = new MobileDetector(userAgent)

      if (this.DEVICE == 'TOTEM') {
        return 'TOTEM'
      }
      // if (md.tablet()) { return "TABLET"};
      if (md.mobile() || md.phone() || md.tablet()) {
        return 'MOBILE'
      }
      return 'DESKTOP'
    },

    isMobile() {
      const userAgent = navigator.userAgent.toUpperCase()
      if (
        /ANDROID|WEBOS|IPHONE|IPOD|BLACKBERRY|IEMOBILE|OPERA MINI/i.test(
          userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
  },

  methods: {
    ...mapActions('booking', ['bookingStoreCommit']),

    ...mapActions('operacao', ['resetBookingDetails']),

    formatDescription(description) {
      return description != undefined ? description.split('(')[0] : null
    },

    closePagamentoModal() {
      this.$emit('closePagamentoModal', false)
    },

    openedFromCatalogModal() {
      try {
        const key = Object.keys(this.$route.query || {})[0]
        if (!key) return false
        return !!JSON.parse(atob(key)).from_modal
      } catch (error) {
        return false
      }
    },

    endCountdown(something) {
      this.endedCountdown = something
    },

    getLimitPaymentDate() {
      let weekday = new Date(this.form.date + ' ' + this.form.time)
        .toLocaleDateString('en', { weekday: 'long' })
        .toLowerCase()

      let end = '00:00'
      if (this.form.atrativo.availability[weekday] != undefined) {
        let end = this.form.atrativo.availability[weekday].find(
          (block) => block.start == this.form.time
        )
        if (end) {
          end = end.end
        }
      }

      const days_in_advance = this.form.atrativo.special_prices[0].find(
        (ticket) => ticket.slug == this.form.booking_slug
      ).days_in_advance
      return moment(`${this.form.date} ${end}`)
        .subtract(days_in_advance, 'days')
        .format('DD/MM/YYYY, HH:mm')
    },

    confirmCloseModalPix() {
      swal
        .fire({
          text: 'Deseja cancelar este pagamento?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, cancelar',
          confirmButtonColor: '#D93051',
          cancelButtonText: 'Voltar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          type: 'default',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.closeModalPix()
          }
        })
    },

    async closeModalSucesso() {
      if (this.webSocketPix != null) {
        await this.webSocketPix.close()
      }

      this.resetFormData()
      this.showSuccessAlert = false
      this.showFailureAlert = false
      this.openBookingDetailsModal = false
      this.endedCountdown = false
      this.paymentStatusMessage = {
        showPaymentStatusMessage: false,
        message: 'Aguardando pagamento...',
      }
      this.bookingStoreCommit({
        mutation: 'RESET_WS_PAYMENT_STATUS',
        value: null,
      })
      this.bookingStoreCommit({
        mutation: 'RESET_MP_CALLBACK_URL_MP',
        value: null,
      })
      this.bookingStoreCommit({
        mutation: 'RESET_EXPRESSBOOKING_RESPONSE',
        value: null,
      })
      this.$parent.$emit('goToSection', 'ingressos')
      this.$parent.$emit('resetExternalReference', null)
      this.$parent.$emit('resetPaymentStatus', null)
      this.$emit('closePagamentoModal', false)
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(
          { type: 'close-express-booking' },
          window.location.origin
        )
        return
      }
      if (this.openedFromCatalogModal()) {
        this.$router.back()
        return
      }
      window.location.reload(true)
    },

    async closeModalPix() {
      if (this.webSocketPix != null) {
        await this.webSocketPix.close()
      }

      this.showSuccessAlert = false
      this.showFailureAlert = false
      this.paymentStatusMessage = {
        showPaymentStatusMessage: false,
        message: 'Aguardando pagamento...',
      }
      this.bookingStoreCommit({
        mutation: 'RESET_WS_PAYMENT_STATUS',
        value: null,
      })
      this.bookingStoreCommit({
        mutation: 'RESET_MP_CALLBACK_URL_MP',
        value: null,
      })
      this.bookingStoreCommit({
        mutation: 'RESET_EXPRESSBOOKING_RESPONSE',
        value: null,
      })
      this.$emit('closePagamentoModal', false)
      this.$parent.$emit('goToSection', 'payment')
      this.form.hash = uuidv4().toUpperCase()
    },

    resetFormData() {
      this.$emit('resetPaymentStatus', null)
      this.bookingStoreCommit({
        mutation: 'RESET_FORM_STANDART_DATA',
        value: this.form,
      })
      this.bookingStoreCommit({
        mutation: 'SET_RESERVA_FORM',
        value: this.form,
      })
    },

    async changeAlertsVisibility() {
      if (this.PAYMENT_STATUS) {
        if (this.PAYMENT_STATUS.toUpperCase() == 'APPROVED') {
          this.showSuccessAlert = true
          this.showFailureAlert = false
          if (this.webSocketPix != null) {
            await this.webSocketPix.close()
          }
        }
        // if(this.PAYMENT_STATUS.toUpperCase() == 'PENDING'){ this.showSuccessAlert = false; this.showFailureAlert = false; this.showPendingAlert = true }
        if (this.PAYMENT_STATUS.toUpperCase() == 'FAILURE') {
          this.showSuccessAlert = false
          this.showFailureAlert = true
        }
      }
    },

    share() {
      const dataShare = {
        title: 'Reserva Expressa',
        text: `Reserva Expressa - ${
          this.bookingDetails.atrativo.name
        } - ${this.bookingDetails.booking_name.replace(/^\w/, (match) =>
          match.toUpperCase()
        )}`,
        url: this.qrCodeOrderUrl,
      }

      if (!navigator.share) {
        let type = 'error'
        this.$notify({ message: 'Erro ao abrir link.', duration: 6000, type })
      } else {
        navigator
          .share(dataShare)
          .then()
          .catch((error) => console.log('Error ao abrir link.', error))
      }
    },

    copyTextToClipboard(copyType) {
      if (copyType == 'pix') {
        if (!navigator.clipboard) {
          this.$notify({
            message: 'Erro ao copiar o Código Pix para área de transferência',
            duration: 6000,
            type: 'error',
          })
          return
        }

        navigator.clipboard
          .writeText(this.expressBookingResponse.additional_data.qr_code)
          .then(() => {
            this.$notify({
              message: 'Códig Pix copiado!',
              duration: 5000,
              type: 'default',
            })
          })
      }

      if (copyType == 'successPayment') {
        if (!navigator.clipboard) {
          this.$notify({
            message: 'Erro ao copiar o link para área de transferência',
            duration: 6000,
            type: 'error',
          })
          return
        }

        navigator.clipboard.writeText(this.qrCodeOrderUrl).then(() => {
          this.$notify({
            message: 'Link da reserva copiado!',
            duration: 5000,
            type: 'default',
          })
        })
      }
    },

    openBookingDetails(target) {
      this.resetBookingDetails()
      if (target) {
        const code = this.payLaterBookingCodeResponse
        if (!code) return
        window.open(`booking-details/${code}`)
        return
      }
      this.openBookingDetailsModal = true
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    closeBookingDetailsModal() {
      this.openBookingDetailsModal = false
      this.$router.push({ path: this.$route.fullPath }).catch((e) => {
        console.warn('NavigationDuplicated prevented')
      })
    },

    checkWsStatus() {
      var vm = this
      this.endedCountdown = false
      this.webSocketPix = new WebSocket(
        `${process.env.VUE_APP_WEBSOCKET_PROTOCOL}:${process.env.VUE_APP_WS_BOCAPIO_URL}`
      )

      this.webSocketPix.onopen = function (event) {
        setInterval(() => {
          vm.webSocketPix.send('PING')
        }, 30000)
      }

      // DESCOMENTAR PARA TESTAR EM DEV
      // setTimeout((d) => {
      //   var event = {data:`{ "Hash": "${this.bookingDetails.hash.toUpperCase()}", "status": "APPROVED"}`}
      //   var data = event.data
      //   console.log('DATA REC ON MESSAGE >>>', event, data);
      //   data = JSON.parse(data)
      //   console.log('DATA AFTER >>>', data,typeof data);
      //   vm.bookingStoreCommit({ mutation: 'SET_WS_PAYMENT_STATUS', value: data })

      // }, 10000);

      // COMENTAR PARA TESTAR EM DEV
      this.webSocketPix.onmessage = function (event) {
        try {
          if (event.data != 'recebido!') {
            var data = event.data
            data = JSON.parse(data)
            vm.bookingStoreCommit({
              mutation: 'SET_WS_PAYMENT_STATUS',
              value: data,
            })
          }
        } catch (error) {
          console.log('ERROR >>>', error)
        }
      }

      // COMENTAR PARA TESTAR EM DEV
      this.webSocketPix.onerror = function (event) {
        if (
          vm.wsStatusPaymentMP == null ||
          vm.wsStatusPaymentMP == undefined ||
          vm.wsStatusPaymentMP.length == 0 ||
          vm.wsStatusPaymentMP.status.toUpperCase() != 'APPROVED'
        ) {
          vm.paymentStatusMessage.message = 'Erro de conexão, cancelando...'
          vm.paymentStatusMessage.showPaymentStatusMessage = true
          vm.closeModalPix()
        }
      }

      // COMENTAR PARA TESTAR EM DEV
      this.webSocketPix.onclose = function (event) {
        if (
          vm.wsStatusPaymentMP == null ||
          vm.wsStatusPaymentMP == undefined ||
          vm.wsStatusPaymentMP.length == 0 ||
          vm.wsStatusPaymentMP.status.toUpperCase() != 'APPROVED'
        ) {
          vm.paymentStatusMessage.message = 'Conexão encerrada, cancelando...'
          vm.paymentStatusMessage.showPaymentStatusMessage = true
          vm.closeModalPix()
        }
      }
    },
  },

  mounted() {
    let queryData = ''
    this.DEVICE = null

    try {
      queryData = JSON.parse(atob(Object.keys(this.$route.query)[0]))
      this.DEVICE = queryData.device == 'toten' ? 'TOTEM' : null
    } catch (error) {}

    if (!this.isPaymentLater) {
      this.checkWsStatus()
      this.changeAlertsVisibility()
    }
    // this.showSuccessAlert = true //habilitar para testes da tela final. remover para produção
  },
}
</script>

<style>
.modal-xl {
  max-width: 50vw;
}

.modal-footer {
  display: flex;
  justify-content: center;
  padding-top: 0;
  height: fit-content;
}

@media screen and (max-width: 1280px) {
  .modal-xl {
    max-width: 60vw;
  }
}

@media screen and (max-width: 870px) {
  .modal-xl {
    max-width: 70vw;
  }
}

@media screen and (max-width: 500px) {
  .modal-xl {
    max-width: 96vw;
    align-self: center;
    padding: 1rem;
    padding: 0px;
  }

  .modal-xl p {
    font-size: smaller;
  }

  .modal-footer {
    padding-bottom: 25px;
  }
}
</style>
